import { render, staticRenderFns } from "./ActivityTypeList.vue?vue&type=template&id=f0d45374&scoped=true"
import script from "./ActivityTypeList.vue?vue&type=script&lang=js"
export * from "./ActivityTypeList.vue?vue&type=script&lang=js"
import style0 from "./ActivityTypeList.vue?vue&type=style&index=0&id=f0d45374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d45374",
  null
  
)

export default component.exports